// Function to add product to cart with the variant ID
var addToCartDirectly = async function (button, variant_id) {
  let data = {
    id: variant_id, // Actual variant ID from the button's data attribute
    quantity: 1,
  };

  // Disable the button and show "Adding..." text
  button.disabled = true;
  let originalText = button.innerHTML;
  button.innerHTML = "Adding...";

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const cartResponse = await response.json();
    console.log("Product added to cart:", cartResponse);

    // Ensure cart is updated before opening the cart drawer
    if (typeof CartDrawer !== 'undefined' && CartDrawer.update) {
      await CartDrawer.update(); 
    }

    setTimeout(async () => {
      if (typeof CartDrawer !== 'undefined' && CartDrawer.open) {
        await CartDrawer.update(); 
        await CartDrawer.setPreEmpty(false);
        await CartDrawer.open(); // Open the drawer after the product is added
        console.log("Cart drawer opened with product");
      } else {
        console.log("CartDrawer object not found or cannot open");
      }

      // Re-enable the button and restore the original text
      button.disabled = false;
      button.innerHTML = originalText;

    }, 800); // Adjust delay if necessary

  } catch (error) {
    console.error("Error adding to cart:", error);
    
    // Re-enable the button and restore the original text in case of error
    button.disabled = false;
    button.innerHTML = originalText;
  }
};

// Function to attach event listeners to all buttons with class 'single-atc-button' and data-variant-id
var attachAddToCartListeners = function () {
  const buttons = document.querySelectorAll('button.single-atc-button[data-variant-id]'); // Select buttons with class and data-variant-id

  if (buttons.length > 0) {
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        const variantId = button.getAttribute("data-variant-id"); // Get variant ID from button's data attribute

        if (variantId) {
          addToCartDirectly(button, variantId); // Call the addToCart function with the button and variant ID
        } else {
          console.error("Variant ID not found on the button");
        }
      });
    });
  } else {
    // console.log("No buttons with class 'single-atc-button' found on the page.");
  }
};

// Call the function to attach event listeners after the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  attachAddToCartListeners();
});


function handleCartDrawerAfterAdd(data) {
  console.log("Item added via gfV3ProductCartButton:", data);

  if (typeof CartDrawer !== 'undefined' && typeof CartDrawer.open === 'function') {
    CartDrawer.setPreEmpty?.(false);
    // CartDrawer.open();
    console.log("Drawer opened");

    let attempts = 0;
    const maxAttempts = 10;
    const variantId = data.variant_id;

    const interval = setInterval(() => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const found = cart.items.some(item => item.variant_id === variantId);
          if (found) {
            console.log("Item confirmed in cart. Updating drawer.");
            CartDrawer.update?.();
            CartDrawer.setPreEmpty?.(false);
            CartDrawer.update?.();
            CartDrawer.removeAttribute('is-empty');
            CartDrawer.open();
            CartDrawer.setPreEmpty?.(false);
            CartDrawer.update?.();
            clearInterval(interval);
          } else {
            console.log(`Item not in cart yet (attempt ${attempts + 1})`);
          }
        })
        .catch(err => {
          console.error("Cart check error:", err);
          clearInterval(interval);
        });

      attempts++;
      if (attempts >= maxAttempts) {
        console.warn("Max cart check attempts reached.");
        clearInterval(interval);
      }
    }, 1000);
  } else {
    console.warn("CartDrawer not found. Dispatching fallback event.");
    document.dispatchEvent(new CustomEvent('cart:open'));
  }
}